import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import { absUrl } from "@/lib/seo";

export const Route = createFileRoute("/integritetspolicy")({
  head: () => ({
    meta: [
      { title: "Integritetspolicy — Tailor's Barber" },
      { name: "description", content: "Tailor's Barbers integritetspolicy och hantering av personuppgifter." },
      { property: "og:url", content: absUrl("/integritetspolicy") },
    ],
    links: [{ rel: "canonical", href: absUrl("/integritetspolicy") }],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <SiteShell>
      <section className="container-page py-16 max-w-3xl">
        <nav className="text-xs text-muted-foreground mb-6">
          <Link to="/" className="hover:underline">Hem</Link>
          <span className="mx-1.5">/</span>
          <span className="text-foreground">Integritetspolicy</span>
        </nav>
        <h1 className="text-4xl md:text-5xl mb-6">Integritetspolicy</h1>
        <div className="max-w-none space-y-4 text-foreground/80 leading-relaxed">
          <p>Tailor&apos;s Barber värnar om din integritet. Denna policy beskriver hur vi samlar in och hanterar personuppgifter.</p>
          <h2 className="text-2xl">Vilka uppgifter vi samlar in</h2>
          <p>Vi samlar in uppgifter som du själv lämnar i samband med bokning via BokaDirekt, kontakt eller drop-in. Vi använder GA4 för anonymiserad webbstatistik.</p>
          <h2 className="text-2xl">Cookies</h2>
          <p>Vi delar in cookies i tre kategorier:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li><strong>Nödvändiga:</strong> krävs för att sidan ska fungera, till exempel ditt cookieval. Dessa kan inte stängas av.</li>
            <li><strong>Statistik:</strong> Google Analytics 4. Hjälper oss förstå hur sajten används. Cookies: _ga, _ga_*. Lagras upp till 2 år.</li>
            <li><strong>Marknadsföring:</strong> Google Ads. Mäter om våra annonser leder till bokningar och gör att annonser kan anpassas. Cookies: _gcl_au, _gcl_aw. Lagras upp till 90 dagar.</li>
          </ul>
          <p>Statistik och marknadsföring används bara om du har samtyckt. Du kan ändra eller återkalla ditt val när som helst via Cookieinställningar i sidfoten. Ditt val sparas i förstapartscookien tb_consent i 12 månader.</p>
          <h2 className="text-2xl">Hur vi använder uppgifterna</h2>
          <p>Uppgifterna används för att leverera bokade tjänster, kommunicera med dig samt förbättra vår webbplats.</p>
          <h2 className="text-2xl">Dina rättigheter</h2>
          <p>Du har rätt att begära utdrag, rättelse och radering av dina uppgifter. Kontakta oss på info@tailorsbarber.se.</p>
        </div>
      </section>
    </SiteShell>
  );
}
